import { Component, Input, OnInit } from '@angular/core';
import {
  EmployeePay,
  MasterPayrollObject,
  Payline,
  PaylineType,
  PayrollConfigSetupData
} from '../../../../models/payroll';
import { PayrollFrequency } from '../../../../models/payroll-info';
import {
  LaborAllocationService,
  PayrollAllocationViewModel
} from '../../../../services/labor-allocation.service';
import { LaborAllocationTypes } from '../../../../models/labor-allocation';
import { KeyPair } from '../../../../models/base';
import { PayrollManagement } from '../../../../tools/payroll-management';

@Component({
  selector: 'payline-labor-allocations-table',
  templateUrl: './payline-labor-allocations-table.component.html',
  styleUrls: ['./payline-labor-allocations-table.component.css'],
  standalone: false
})
export class PaylineLaborAllocationsTableComponent implements OnInit {
  @Input() allocTypeId: number;
  @Input() clientCode: string;
  @Input() configSetupData: PayrollConfigSetupData;
  @Input() jobCodes: KeyPair[];
  @Input() pay: EmployeePay;
  @Input() payroll: MasterPayrollObject;

  public loaded: boolean = false;
  // paylines that are ok to pay
  // with earnings/deductions/taxes
  // filtered by only those that have
  // either current or YTD amounts
  public paylines: Payline[] = [];
  public allocations: Record<number, PayrollAllocationViewModel[]> = {};
  public allocationPercentages: Record<string, number> = {};

  public readonly paylineType: typeof PaylineType = PaylineType;

  get payrollFrequencies() {
    return PayrollFrequency;
  }

  get LaborAllocationType() {
    return LaborAllocationTypes[this.allocTypeId];
  }

  constructor(
    public laborAllocations: LaborAllocationService,
    public payrollMgmt: PayrollManagement
  ) {}

  ngOnInit(): void {
    this.laborAllocations.init(this.allocTypeId, this.configSetupData, this.jobCodes);
    this.paylines = this._filterPaylines();

    if (!this.paylines.filter(x => x.OkToPay).length) {
      return; // do not render anything
    }

    this.paylines.forEach(payline => {
      this.allocations[payline.PaylineId] = this.laborAllocations.SplitAllocations(
        payline,
        this.pay
      );
    });

    Object.entries(this.allocations).forEach(([id, allocation]) => {
      let total = 0;
      allocation.forEach(vm => {
        if (vm.allocation.TemporaryHourlyAllocations != null) {
        }
      });
    });

    this._sortDeductions();
    this._sortEarnings();
    this.loaded = true;
  }

  // #region private methods

  private _filterPaylines() {
    const paylines = [];

    this.pay.Paylines.forEach(pay => {
      if (!pay.OkToPay) {
        return;
      }

      let line = { ...pay };

      line.Earnings = pay.Earnings.filter(x => {
        return x.Hours || x.YTDHours || x.CurrentAmount || x.YTDAmount;
      });

      line.Deductions = pay.Deductions.filter(x => {
        return x.CurrentAmount || x.YTDAmount;
      });

      line.Taxes = pay.Taxes.filter(x => {
        // only display taxes paid by the employee
        return x.TaxPaidBy === 'E' && (x.CurrentAmount || x.YTDAmount);
      });

      paylines.push(line);
    });

    return paylines;
  }

  private _sortDeductions() {
    this.paylines.forEach(line => {
      line.Deductions.sort((a, b) => {
        let left = this.laborAllocations._getDeductionConfig(a.DeductionCode);
        let right = this.laborAllocations._getDeductionConfig(b.DeductionCode);

        return left.AppearanceSequence - right.AppearanceSequence;
      });
    });
  }

  private _sortEarnings() {
    this.paylines.forEach(line => {
      line.Earnings.sort((a, b) => {
        let left = this.laborAllocations._getEarningConfig(a.EarningId);
        let right = this.laborAllocations._getEarningConfig(b.EarningId);

        return left.AppearanceSequence - right.AppearanceSequence;
      });
    });
  }
  // #endregion
}
